(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-fkp-product]').forEach((root) => {
      if (root.dataset.fkpReady) return;
      root.dataset.fkpReady = 'true';
      const variants = JSON.parse(root.querySelector('[data-fkp-variants]').textContent);
      const labels = JSON.parse(root.querySelector('[data-fkp-labels]').textContent);
      const groups = [...root.querySelectorAll('[data-fkp-option]')];
      const select = root.querySelector('[data-fkp-variant]');
      const price = root.querySelector('[data-fkp-price]');
      const compare = root.querySelector('[data-fkp-compare]');
      const submit = root.querySelector('[data-fkp-add]');
      const form = select.closest('form');
      const selectedOptions = () => groups.map(group => group.querySelector('input:checked')?.value);
      const currentVariant = () => groups.length ? variants.find(variant => variant.options.every((value, i) => value === selectedOptions()[i])) : variants[0];
      const update = (changeUrl = false) => {
        const variant = currentVariant();
        groups.forEach((group, index) => {
          group.querySelector('[data-fkp-selected]').textContent = selectedOptions()[index] || '';
          group.querySelectorAll('input').forEach(input => {
            const options = selectedOptions();
            options[index] = input.value;
            input.disabled = !variants.some(item => item.options.every((value, i) => value === options[i]));
          });
        });
        submit.disabled = !variant?.available;
        submit.textContent = variant ? variant.available ? labels.add : labels.sold : labels.unavailable;
        if (!variant) { select.value = ''; return; }
        select.value = String(variant.id);
        price.textContent = variant.price;
        compare.textContent = variant.compare;
        compare.hidden = !variant.compare;
        document.querySelectorAll('[data-fkp-final-price]').forEach(node => {node.textContent = variant.price;});
        const gallery = root.querySelector('[data-fiaco-product-gallery]');
        if (variant.image) gallery?.fiacoGallery?.selectMedia(variant.image);
        if (changeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };
      root.querySelector('[data-fkp-enhanced]').hidden = false;
      root.querySelector('[data-fkp-native]').hidden = true;
      groups.forEach(group => group.addEventListener('change', () => update(true)));
      form.addEventListener('submit', event => {if (!currentVariant()?.available) event.preventDefault();});
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = variants.find(item => String(item.id) === id);
        if (!variant) return;
        groups.forEach((group, i) => group.querySelectorAll('input').forEach(input => {input.checked = input.value === variant.options[i];}));
        update();
      });
      update();
    });
    document.querySelectorAll('[data-fkp-return]').forEach(link => {
      link.href = '#FiacoKeepsakeTop';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
